export default {
	cookie: {
		title: 'Cookies helfen uns bei der Bereitstellung unseres Dienstes.',
		text: 'Verantwortlicher der Datenverarbeitung ist Ihre Hausverwaltung. Wenden Sie sich bitte an diese für Informationen zur Datenverarbeitung. Diese Seite erzeugt lediglich technisch notwendige Cookies. Ihre Zustimmung zur Verarbeitung sonstiger Cookies, etwa zur Reichweitenmessung, ist daher nicht erforderlich. Mit einem Klick auf “Okay” bestätigen die Sie lediglich Ihre Kenntnisnahme dieser Hinweise und stimmen nicht der Verwendung sonstiger Cookies zu.',
	},
}
